import React from "react";
import "./PopupCol.scss";

export function PopupCol({ children }) {
  return <div className="popup__col">{children}</div>;
}
